module.exports = __webpack_public_path__ + "static/media/Boton_capacitate.686e7c1e.webp";